import React, { useState, useEffect, useRef } from "react";
import Loader from "../../../ReusableComponents/Loader";
import {
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  TextField,


  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Divider

} from "@mui/material";
import Modal from "../../../ReusableComponents/Modal";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import {
  getAllIssueResponseByIssueID,
  postIssueResponse,
  changeIssueAssignee,
} from "../../../apis/BhuMeetTeams/Oparations/requestIssue";
import { getTelecallerTeams } from "../../../apis/adminAPIs/teams";
import IssueMetaData from "./IssueDetailMetadata";
import { Button } from "../../../Components/Helper";
import MainContentWrapper from "../../../Components/MainContentWrapper";
import Popup from "../../../ReusableFunctions/Popup";
import SelectComponent from "../../../ReusableComponents/SelectComponent";
import { GLOBAL_STYLES } from "../../../appConstants";


export const RequestIssueDetail = () => {
  const scrollRef = useRef(null);
  const location = useLocation();
  const userDetails = useSelector((state) => state.user?.user);
  const role =
    userDetails.bhumeet_role === "Admin"
      ? "operations"
      : userDetails.bhumeet_role == 'Telecaller' ? 'telecaller' : "customerSuccessEngineer";

  // Data coming from the location state
  const [issueDetail, setIssueDetail] = useState(location.state.IssueDetail);
  const issueID = location.state.issueID;

  // Local states
  const [allIssuesResponse, setAllIssuesResponse] = useState([]);
  const [ResponseDetails, setResponseDetails] = useState([]);
  const [responseText, setResponseText] = useState("");
  const [responseTextError, setResponseTextError] = useState("");

  const [loading, setloading] = useState(true)

  // State for changing assignee
  const [assigneeDialogOpen, setAssigneeDialogOpen] = useState(false);
  const [selectedAssignee, setSelectedAssignee] = useState(issueDetail.assignee);
  const [allasignee, setAllAssignee] = useState([])
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    fetchIssueData();
  }, [refresh])
  useEffect(() => {
    fetchIssueData();
    setResponseText(localStorage.getItem("issueCommentHistory") || "");
    console.log(location.state)
    let url = userDetails.bhumeet_role == 'Admin' ? '/bhumeet_team/admin/manage_team/telecallerteam' : userDetails.bhumeet_role == 'Telecaller' ? '/bhumeet_team/telecaller/requestissue/getUsers' : '/bhumeet_team/customerSuccessEngineer/requestissue/getUsers'


    getTelecallerTeams(["Admin", "Customer support engineer"], url).then(res => {
      setAllAssignee(res)
    })
  }, []);

  const fetchIssueData = async () => {
    try {
      const res = await getAllIssueResponseByIssueID({ IssueID: issueID }, role);
      setloading(false)
      setAllIssuesResponse(res.RequestIssue);
      setResponseDetails(res.RequestDetail)
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        console.log("Scrolled")
      }
    } catch (err) {
      console.error("Error fetching issue data", err);
    }
  };

  const handleResponseSubmit = async (isclosed) => {
    try {
      if (!responseText.trim()) {
        setResponseTextError(true);
        return;
      }
      let updatedResponseText = responseText;
      setResponseTextError(false);
      if(ResponseDetails.status === 'close'){
        updatedResponseText ="Reopened Issue with comment: "+responseText
        setIssueDetail({ ...issueDetail, status: "open" });
      }
      await postIssueResponse(
        { response: updatedResponseText, issueId: issueID, assignee: issueDetail.assignee, isclosed,currentStatus:ResponseDetails.status },
        role
      );
      
      
      if (isclosed) {
        window.history.back();
      }else{
        fetchIssueData()
      }
      setResponseText("");
      localStorage.setItem("issueCommentHistory", "");
      fetchIssueData();

    } catch (err) {
      console.error("Error submitting response", err);
    }
  };

  const handleAssigneeUpdate = async () => {
    try {
      changeIssueAssignee(selectedAssignee, issueID, role);
       Popup.alert("SUCCESS", "Assignee has been changed successfully", "SUCCESS")
      window.history.back();
      setAssigneeDialogOpen(false);
      fetchIssueData();
    } catch (err) {
      console.error("Error updating assignee", err);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && responseText.trim() && !event.shiftKey) {
      handleResponseSubmit(false);
    }
  };

  return (

    <MainContentWrapper containerStyle={{ overflow: "hidden",paddingTop:"0px" }} header={"Issue Detail"}>


      <Container style={{ paddingTop:"0px", marginLeft: "0px", padding: "0px", maxWidth: "100%", marginTop: "0px",maxHeight:"100%" }} maxWidth="lg" sx={{ mt: 3, mb: 3 }}>
        <Grid style={{ padding: "3px",height:"100%",paddingTop:"0px" }} container spacing={2}>
          {/* Left Column: Main Issue and Conversation */}
          <Grid
            item xs={12} md={9}
            sx={{ display: "flex", flexDirection: "column", height: "calc(100vh - 100px)" ,paddingTop:"0px"}}>
            {/* Issue Details Card */}
            <Paper
              elevation={3}
              sx={{
                p: 2,
                mb: 2,
                overflow: "visible",  // Allow content to expand
                marginBottom: "7px"
              }}
            >
              <Typography
                style={{ fontSize: "1rem", fontWeight: "500" }}
                variant="div"
                gutterBottom
                sx={{
                  wordBreak: "break-word",
                  whiteSpace: "pre-wrap",  // Ensures multiline text is displayed properly
                  overflow: "visible",     // Allows text to fully display
                }}
              >
                {issueDetail.note || "Issue Title missing"}
              </Typography>
            </Paper>



            <Loader open={loading} />

            {/* Conversation Section - Takes up remaining space */}
            <Box
              ref={scrollRef}
              sx={{
                flexGrow: 1,
                overflowY: "auto",
                p: 2,
                paddingBottom:"25px",
                maxHeight: "60vh" // Adjust max height based on your UI 
              }}
            >
              {allIssuesResponse.map((response, index) => (
  <Box
    key={index}
    sx={{
      position: "relative", // Parent for the absolute line
      display: "flex",
      mb: 2,
      alignItems: "flex-start",
    }}
  >
    {/* Vertical Line as a sibling element */}
    {(index !== allIssuesResponse.length - 1 || ResponseDetails.status === 'open') && (
      <Box
        sx={{
          position: "absolute",
          // Adjust left to align the line behind the avatar (for example, if the avatar container’s width is about 32px + some padding)
          left: "calc(2rem / 2)", // tweak this value to match your layout
          top: "-8px",
          bottom: "-8px",
          width: 2,
          backgroundColor: "#30363d",
          transform: "translateX(-50%)",
          zIndex: 0,
        }}
      />
    )}

    {/* Avatar Container */}
    <Box sx={{ mr: 2, zIndex: 1 }}>
      <Avatar
        sx={{
          width: 32,
          height: 32,
          backgroundColor: "#58a6ff",
          marginTop: "11px",
          zIndex: 2,
        }}
      >
        {response.name ? response.name[0].toUpperCase() : "?"}
      </Avatar>
    </Box>

    {/* Comment Content */}
    <Paper
      sx={{
        flex: 1,
        p: 1.5,
        border: "1px solid rgb(213, 227, 244)",
        borderRadius: "6px",
        color: "#c9d1d9",
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
        <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#58a6ff" }}>
          {response.name}
        </Typography>
        <Typography variant="caption" sx={{ color: "#8b949e" }}>
          {new Date(response.date_created).toLocaleString()}
        </Typography>
      </Box>
      <Divider sx={{ mb: 1, borderColor: "#30363d" }} />
      <Typography
        variant="body2"
        style={{ color: "black" }}
        sx={{
          wordBreak: "break-word",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
        }}
      >
        {(index !== allIssuesResponse.length - 1 || ResponseDetails.status === 'open')
          ? response.response_note
          : ResponseDetails.status === "close" &&
            index === allIssuesResponse.length - 1 && (
              <>
                <strong>Closed with comment:</strong> {response.response_note}
              </>
            )}
      </Typography>
    </Paper>
  </Box>
))}

            </Box>

            {/* Add Comment Section (Sticky at Bottom) */}
            {(true) && (
              <Paper elevation={3} sx={{ p: 2, position: "sticky", bottom: 0, backgroundColor: "white", zIndex: 2, marginTop: "27px" }}>
                <Typography style={{ fontSize: "1rem", fontWeight: "500" }} variant="span" gutterBottom>
                  Add Comment
                </Typography>
                <TextField
                  onKeyDown={handleKeyDown}
                  multiline
                  minRows={2}
                  fullWidth
                  maxRows={3}
                  variant="outlined"
                  placeholder="Write a comment..."
                  disabled={ResponseDetails.status === 'close' && userDetails.bhumeet_role !== 'Telecaller'}
                  value={responseText}
                  error={responseTextError}
                  onChange={(e) => {
                    if (e.target.value.length < 500) {
                      setResponseText(e.target.value);
                      localStorage.setItem("issueCommentHistory", e.target.value);
                    }
                  }}
                />
                <Box mt={2} display="flex" gap="10px" whiteSpace={"nowrap"} justifyContent="flex-end">
                  {(ResponseDetails.status === 'open' && userDetails.bhumeet_role === 'Admin') &&
                  <Button
                  style={{ width: "100%" }}
                  text={"Close with Comment"}
                  onClick={() => { handleResponseSubmit(true); }}
                  className="btn-large"
                />
                  }
                  {(ResponseDetails.status === 'close' && userDetails.bhumeet_role === 'Telecaller') &&
                  <Button
                  // isDisabled={(ResponseDetails.status === 'close' && userDetails.bhumeet_role !== 'Telecaller')}
                  style={{ width: "100%" }}
                  text={"Reopen with Comment"}
                  onClick={() => { handleResponseSubmit(); }}
                  className="btn-large"
                />
                  }
                  
                  {ResponseDetails.status === 'open' && (
                    <Button
                      text="Comment"
                      disabled={!responseText.trim()}
                      onClick={() => { handleResponseSubmit(false); }}
                      className="btn-large"
                    />
                  )}
                </Box>
              </Paper>
            )}
          </Grid>


          {/* Right Column: Sidebar */}
          <Grid item xs={12} md={3} sx={{height:"95%",overflow:"auto",paddingTop:"0px !important",marginTop:"15px"}}>
            {/* Assignees Card */}
            <Paper elevation={3} sx={{ p: 2, mb: 2,
              // position:"sticky", 
              // top:"-16px",
              // zIndex:"2"
             }}>
              <Box
                display="flex"
                
                justifyContent="space-between"
                alignItems="center"
                mb={1}
              >
                <Typography style={{ fontSize: "17px", fontWeight: "700" }} variant="span">Assignee</Typography>
                {((issueDetail.assignee === userDetails.id ||
                  userDetails.bhumeet_role === "Admin") && ResponseDetails.status == 'open') && (


                    <Button text="Change" onClick={() => setAssigneeDialogOpen(true)} className="btn-large" />
                  )}
              </Box>
              <List>

                <ListItem disablePadding>
                  <ListItemAvatar>
                    <Avatar>
                      {ResponseDetails.name ? ResponseDetails.name[0]?.toUpperCase() : "?"}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={ResponseDetails.name || 'Not Found'} />
                </ListItem>
              </List>
            </Paper>

            <IssueMetaData key={refresh} restart={(e) => {
              console.log(e)
              setRefresh(e)
            }} issueDetail={issueDetail} request_detail={ResponseDetails} />
          </Grid>
        </Grid>

        {/* Dialog for Changing Assignee */}


        <Modal
          header={"Change Assignee"}
          contentStyle={{ width: "30%", height: "250px" }}
          headingStyle={{ fontSize: "18px", fontWeight: 600 }}
          headerContainerStyle={{ padding: "20px" }}
          open={assigneeDialogOpen}
          onClose={() => setAssigneeDialogOpen(false)}
        >

          <div style={{ padding: "20px 30px", display: "flex", flexDirection: "column", width: "100%", gap: "20px" }}>
            {/* Date Filter Section */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", maxWidth: "100px", gap: "10%" }}>
              {/* {JSON.stringify(selectedAssignee)} */}
              {/* <label></label> */}
              <SelectComponent
                onChange={(e) => {
                  console.log(e)
                  // setIssueType(e)
                  setSelectedAssignee(e.value)
                }}
                isSearchable={true}
                name="changeAssignee"
                label="changeAssignee"
                list={allasignee.map(x => ({ label: x.name, value: x.id }))}
                styles={{ width: "200px", height: "18px", fontSize: "13px" }}
                // validation={selectFieldValidation}
                placeholderText="changeAssignee"
                // defaultValue={selectedAssignee}
                value={allasignee.find(x => x.id == selectedAssignee)
                  ? { label: allasignee.find(x => x.id == selectedAssignee).name, value: selectedAssignee }
                  : null}
                containerStyle={{ width: "100px", minHeight: "60px" }}
                valueContainerStyle={{ width: "200px" }}
              />

            </div>
          </div>


          <div style={{ display: "flex", justifyContent: "space-between", padding: "20px 30px", borderTop: '0.5px solid #BFC8D9' }}>

            <Button
              text={"Cancel"}
              style={{ width: "130px", height: "38px", fontSize: "15px", marginRight: "10px" }}
              onClick={() => {
                setAssigneeDialogOpen(false)
              }}
            />
            <Button
              text={"Update"}
              isDisabled={selectedAssignee == issueDetail.assignee || (selectedAssignee == userDetails.id && userDetails.bhumeet_role != 'Admin')}
              style={{ width: "130px", height: "38px", fontSize: "15px", marginRight: "10px" }}
              onClick={handleAssigneeUpdate}
            />
          </div>
        </Modal>
      </Container>


    </MainContentWrapper>

  );
};

export default RequestIssueDetail;
